import { Trans } from "@web-monorepo/i18n/macro";
import { DDSButton } from "@web-monorepo/dds";

type FollowProps = {
  user: { type: string } | null;
  following: { channelName: string }[];
  boardSlug: string;
};

function Follow({ user, following, boardSlug }: FollowProps) {
  if (following === null) {
    following = [];
  }

  if (!user) {
    return null;
  }

  const isTeacher = user && user.type === "teacher";

  if (!isTeacher) {
    return null;
  }

  const isFollowing = following.find(({ channelName }) => channelName === boardSlug);

  return isFollowing ? (
    <DDSButton data-name="follow:follow.following" size="small" disabled={Boolean(isFollowing)}>
      <Trans>Following</Trans>
    </DDSButton>
  ) : (
    <DDSButton data-name="follow:follow.follow" size="small" disabled={Boolean(isFollowing)}>
      <Trans>Follow</Trans>
    </DDSButton>
  );
}

export default Follow;
